import { standardColors, nonStandardColors, oxideColors } from './constant';

/**
 * Get the image code for a given color code
 * If the color has an 'img' property, use that; otherwise use the 'code'
 * @param {string} colorCode - The color code (e.g., 'ral_9910')
 * @returns {string} - The image code to use for file paths (e.g., 'ral_9016')
 */
export const getImageCode = (colorCode) => {
    // Search through all color arrays to find the matching color
    const allColors = [...standardColors, ...nonStandardColors, ...oxideColors];

    const foundColor = allColors.find(color => color.code === colorCode);

    // Return the img property if it exists, otherwise return the original code
    return foundColor?.img || colorCode;
};
